<template>
    <div class="animated fadeIn">     
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                    <strong>Assign Access</strong>
                    </div>
                    <b-row>
                        <b-col md="12" class="my-1" style="text-align: center; color:#20a8d8;">
                        <h4>Please Select Pages For permission</h4>
                        </b-col>
                    </b-row>

                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                    </div>

                    <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                        <b-row>
                            <b-col md="5">
                                <ul>
                                    <li>
                                        <div class="d-flex justify-content-between align-items-start">
                                            <b>Module Name</b>
                                            <b>Read Only Access</b>
                                        </div>
                                       <br>
                                       <div class="d-flex justify-content-flex-start align-items-baseline">
                                        <input type="checkbox" id="selectAll" v-model="selectAll" @change="selectAllItems">&nbsp;
                                        <label for="selectAll">Select All</label>
                                       </div>
                                        <ul>
                                            <li v-for="(parent, parentIndex) in parents" :key="parentIndex" :class="parent.child.length == 0 ? 'd-flex justify-content-between align-items-baseline' : ''">
                                                <div class="checkbox-container">
                                                    <input 
                                                        type="checkbox" 
                                                        :id="'parent-' + parentIndex" 
                                                        v-model="parent.checked" 
                                                        @change="toggleChildren(parentIndex)"
                                                    >&nbsp;
                                                    <label :for="'parent-' + parentIndex" class="mt-2">{{ parent.title }}</label>
                                                </div>
                                                <b-form-checkbox 
                                                    switch 
                                                    v-model="parent.isReadonly" 
                                                    class="ml-auto mt-2"
                                                    v-if="parent.title === 'Load Management' || parent.title === 'Incident Master' || parent.title === 'Plan Upload' || parent.title === 'Direct Dispatch'"
                                                >
                                                <!-- || parent.title === 'Plan Upload' || parent.title === 'Direct Dispatch' -->
                                                    <span class="sr-only">Switch for {{ parent.title }}</span>
                                                </b-form-checkbox>
                                                <ul v-if="parent.child.length > 0">
                                                    <li v-for="(child, childIndex) in parent.child" :key="'child-' + parentIndex + '-' + childIndex" class="list-item">
                                                        <div class="checkbox-container">
                                                            <input 
                                                                type="checkbox" 
                                                                :id="'child-' + parentIndex + '-' + childIndex" 
                                                                v-model="child.checked" 
                                                                @change="updateParentCheckbox(parentIndex)"
                                                            >&nbsp;
                                                            <label :for="'child-' + parentIndex + '-' + childIndex" class="mt-2">{{ child.title }}</label>
                                                        </div>
                                                        <b-form-checkbox 
                                                            switch 
                                                            v-model="child.isReadonly"
                                                            class="ml-auto mt-1"
                                                            v-if="checkShowSwitch(child.title)"
                                                        >
                                                            <span class="sr-only">Switch for {{ child.title }}</span>
                                                        </b-form-checkbox>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                
                            </b-col>

                            <b-col md="2">
                                <span class="btn btn-primary" title="Reset Access" @click="resetAccess()" >Reset</span> &nbsp;
                                <span class="btn btn-danger" title="Clear Access" @click="clearAccess()" >Clear</span>
                            </b-col>

                            <b-col md="5" class="my-1" >
                                <b-form-group label="Select Default Page" :label-cols="4">                   
                                    <v-select id="mySelect" v-model="customer.defaultpage" :options="data" name="defaultpage" v-validate="'required'" placeholder="Select Default Page" :class="{ danger: errors.has('defaultpage') }">
                                    </v-select>
                                    <b-input-group class="mb-3">
                                        <span style="width:240px" v-show="errors.has('form-1.defaultpage')" class="help text-danger">{{ errors.first('form-1.defaultpage') }} Please Select Default Page</span>
                                    </b-input-group>  
                                </b-form-group> 
                                <span style="color:red;font-size">Note: Please Check and Uncheck checkbox in Sequence</span>
                            </b-col>
                        </b-row>

                        <b-col md="12" class="my-1">
                            <button class="btn btn-lg btn-primary"  type="submit" >Save</button>
                        </b-col>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'

export default {
    name: 'access', 
    data() {
        return {
            loader:false,
            route_id:'',
            id:'',
            userType:'',
            data: ['dashboard_adv','trip_history'],
            customer:{},

            userdata : [],
            user_access_listing : [],
            parents : [],
            userparents : [],

            selectAll: false,
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

        this.route_id=this.$route.params.id;

        const myArr = this.route_id.split(" ");

        this.id = myArr[0];

        this.userType = myArr[1];

        if(this.userType==1 || this.userType==2){
            this.data=['dashboard_adv'];
        }
        else{
            this.data=['dashboard_adv','trip_history'];
        }

        this.displaydata();
    },

    watch: {
        parents: {
        handler: function(val) {
            this.selectAll = val.length > 0 && val.every(parent => parent.checked);
        },
        deep: true,
        },
    },

    methods: {
          // Method to determine whether the switch should be shown
         checkShowSwitch(title) {
            const switchTitles = [
                'Bulk Reallocation', 'Reallocate Shipment', 'Mark Delivery', 'Mark Booking Done', 
                'Adhoc Allocation', 'Bulk Status Update', 'Mark Pickup Done' ,'EBN Extension', 'Pick Done', 'Daily Trip', 'Direct Dispatch',
                'Hub Management', 'Route Details', 'Zone Management', 'Adhoc Vehicle', 'Vehicle Master', 'Transporter Master', 'Load Management', 'Destination Master', 'Destination Group Master','Constraint Master', 'Origin Master', 'Origin Group Master', 'Zone Master', 'PDA Configuration', 'Route Mapping', 'Route History', 'Route Configuration', 
                'Plan Upload', 'Daily Plan Upload'
            ];
            return switchTitles.includes(title);
        },

        displaydata: function () {
            this.loader=true;
            this.userdata = [];
            this.user_access_listing = [];
            this.userparents = [];
            this.parents = [];

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj = {
                sysusermasterid:this.id,
                usertype:this.userType=='3'?'3':this.userType=='4'?'3':this.userType,
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/menuAccessListing`,obj)
            .then((result) => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.userdata = result.body.returnvalue[0].body;
                    this.user_access_listing = result.body.user_aceess_listing[0].body;

                    this.customer.defaultpage = result.body.user_aceess_listing[0].defaultpage;

                    // Convert empty string child to empty array
                    this.userdata.forEach(item => {
                        if (item.child === "") {
                            item.child = [];
                        }
                    });

                    // Initialize a new array to store the results
                    let user_result = [];

                    // Iterate through userdata to compare with user_access_listing
                    this.userdata.forEach(ud => {
                        // Find matching entry in user_access_listing based on href and title
                        let matchedParent = this.user_access_listing ? this.user_access_listing.find(ua => ua.href === ud.href && ua.title === ud.title) : null;

                        // Initialize checked as false by default
                        let checked = false;

                        // If there is a matched parent in user_access_listing
                        if (matchedParent) {
                            // Check if all child items are present and checked in user_access_listing
                            if (ud.child.length === 0) {
                                checked = true; // No children to check, default to true
                            } else {
                                checked = ud.child.every(child => {
                                    // Ensure matchedParent.child is an array before using array methods
                                    if (Array.isArray(matchedParent.child)) {
                                        // Check if each child exists in matchedParent.child with the same properties
                                        let matchedChild = matchedParent.child.find(mc => mc.href === child.href && mc.title === child.title);
                                        return matchedChild !== undefined;
                                    }
                                    return false; // Default to false if matchedParent.child is not an array
                                });
                            }
                        }

                        // Create a new entry with checked and other properties
                        let newEntry = {
                            href: ud.href,
                            icon: ud.icon,
                            child: ud.child.map(c => ({
                                href: c.href,
                                icon: c.icon,
                                title: c.title,
                                isReadonly: matchedParent ? (Array.isArray(matchedParent.child) ? matchedParent.child.some(mc => mc.href === c.href && mc.title === c.title && mc.isReadonly) : c.isReadonly) : c.isReadonly,
                                checked: matchedParent ? (Array.isArray(matchedParent.child) ? matchedParent.child.some(mc => mc.href === c.href && mc.title === c.title) : false) : false
                            })),
                            title: ud.title,
                            checked: checked,
                            isReadonly: matchedParent ? matchedParent.isReadonly : false
                        };

                        // Push the new entry to the user_result array
                        user_result.push(newEntry);
                    });

                    this.userparents = user_result;
                    this.parents = this.userparents.map(item => ({
                        ...item,
                        child: item.child.map(childItem => ({ ...childItem })),
                    }));
                    // Print the result array with formatted child objects
                    // console.log(JSON.stringify(result, null, 2)); // 2 spaces for indentation

                } else {
                    this.userdata = [];
                    this.user_access_listing = [];
                    this.userparents = [];
                    this.parents = [];
                }

            })
            .catch((ex) => {
                console.log('error-----', ex)
            })
        },

        selectAllItems() {
            const newCheckedState = this.selectAll;
            this.parents.forEach((parent) => {
                parent.checked = newCheckedState;
                if (parent.child.length > 0) {
                parent.child.forEach((child) => {
                    child.checked = newCheckedState;
                });
                }
            });
            this.updateReadonlyState();
        },
        
        toggleChildren(parentIndex) {
            const parent = this.parents[parentIndex];
            if (parent.child.length > 0) {
                parent.child.forEach((child) => {
                child.checked = parent.checked;
                });
            }
            this.updateSelectAllState();
            this.updateReadonlyState();
        },
        
        updateParentCheckbox(parentIndex) {
            const parent = this.parents[parentIndex];
            const allChecked = parent.child.length > 0 && parent.child.every((child) => child.checked);
            parent.checked = allChecked;
            this.updateSelectAllState();
            this.updateReadonlyState();
        },
        
        updateSelectAllState() {
            this.selectAll = this.parents.length > 0 && this.parents.every((parent) => parent.checked);
        },
    
        updateReadonlyState() {
            this.parents.forEach(parent => {
                if (!parent.checked && parent.child.every(child => !child.checked)) {
                parent.isReadonly = false;
                }
                parent.child.forEach(child => {
                if (!child.checked) {
                    child.isReadonly = false;
                }
                });
            });
        },
            

        resetAccess(){
            this.userdata = [];
            this.user_access_listing = [];
            this.userparents = [];
            this.parents = [];
            this.selectAll = false;
            this.displaydata();
        },

        clearAccess(){
            this.parents.forEach(parent => {
                parent.checked = false;
                parent.child.forEach(child => {
                child.checked = false;
                });
            });
            this.selectAll = false;
            this.updateReadonlyState();
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {    
                this.saveCheckedItems();
                }
            });
        },

        saveCheckedItems() {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (this.parents.length==0) {
                this.$fire({
                    text: "Please Assign Access to User",
                    type: "warning",
                    timer: 30000
                });
                this.loader=false;
                return false;

            }

            // const checkedItems = this.parents.map(parent => {
            //     const checkedChildren = parent.child.filter(child => child.checked);
            //     return {
            //     ...parent,
            //     child: checkedChildren,
            //     checked: parent.checked,
            //     };
            // }).filter(parent => parent.checked || parent.child.length > 0);
         

            // const checkedItems = this.parents.map(parent => {
            //     const checkedChildren = parent.child.filter(child => child.checked);
            //     return {
            //         href: parent.href,
            //         icon: parent.icon,
            //         child: checkedChildren.length > 0 ? checkedChildren : "",
            //         title: parent.title,
            //         isReadonly: parent.isReadonly
            //     };
            // });
            console.log(" this.parents", this.parents)
            const checkedItems = this.parents
            .filter(parent => (parent.checked || parent.child.some(child => child.checked))) // Filter parents that are checked or have checked children
            .map(parent => {
                const checkedChildren = parent.child
                .filter(child => child.checked) // Filter only checked children
                .map(({ href, icon, title, isReadonly }) => ({ href, icon, title, isReadonly })); // Map to new objects without 'checked'
                
                return {
                href: parent.href,
                icon: parent.icon,
                child: checkedChildren.length > 0 ? checkedChildren : "", // Add children only if there are checked children
                title: parent.title,
                isReadonly: parent.isReadonly
                };
            });


            let obj = {
                sysusermasterid:this.id ,
                menubody: checkedItems,
                defaultpage: this.customer.defaultpage,
            }
            
            // return false;
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updateMenuAccess`,obj)
                .then((result) => {
                    this.loader=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "success",
                            timer: 30000
                        });
                        if(this.id==userInfo.sysusermasterid){
                            localStorage.setItem('userData', '')
                            this.$router.push('/login');
                        }else{
                            this.$router.push('/adminuser_mr');
                        }
                        
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            });
                    
                    }
                }).catch((ex) => {
                    console.log('error-----', ex)
                })
            // const checkedItems = this.parents.map(parent => {
            //     const checkedChildren = parent.child.filter(child => child.checked);
            //     return {
            //     ...parent,
            //     child: checkedChildren,
            //     checked: parent.checked,
            //     };
            // }).filter(parent => parent.checked || parent.child.length > 0);

            // console.log('Saved Items:', checkedItems);
            // Here you can send checkedItems to your backend or handle it as needed
        },
    },
}
</script>

<style scoped>
.checkbox-container {
    display: flex;
    align-items: center;
}

.list-item {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}


</style>
